import { render, staticRenderFns } from "./orgDialog.vue?vue&type=template&id=537aae84&scoped=true&"
import script from "./orgDialog.vue?vue&type=script&lang=js&"
export * from "./orgDialog.vue?vue&type=script&lang=js&"
import style0 from "./orgDialog.vue?vue&type=style&index=0&id=537aae84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537aae84",
  null
  
)

export default component.exports